import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, IconButton } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaLock, FaPencilAlt, FaSave } from 'react-icons/fa';
import theme from '../../theme.js';
import { useCharacter } from './Contexts/CharacterInfo.js';

const LockButton = ({ onChangeLocked, onChangePageHeader, onMissingName }) => {
  const lockIcon = <FaLock style={{ fontSize: '1.2rem' }} />;
  const pencilIcon = <FaPencilAlt style={{ fontSize: '1.5rem' }} />;
  const saveIcon = <FaSave style={{ fontSize: '1.5rem' }} />;

  const { character, saveCharacter, loaded } = useCharacter();
  const [buttonIcon, setButtonIcon] = useState(lockIcon);
  const [isLocked, setIsLocked] = useState(false);
  const [location, setLocation] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const loc = useLocation();

  const handleLockClick = () => {
    if (character.unsavedChanges && character.name === '') {
      onMissingName(true);
      return;
    }

    onMissingName(false);
    const newLockVal = !isLocked;
    setIsLocked(newLockVal);
    onChangeLocked(newLockVal);
    if (newLockVal) {
      setButtonIcon(pencilIcon);
      if (character.name) {
        onChangePageHeader(character.name);
        if (character.unsavedChanges) {
          saveCharacter();
        }
      } else onChangePageHeader('Character Page');
    } else setButtonIcon(lockIcon);
  };

  const setLock = useCallback(
    lockVal => {
      if (lockVal) setButtonIcon(pencilIcon);
      else setButtonIcon(lockIcon);

      setIsLocked(lockVal);
      onChangeLocked(lockVal);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChangeLocked]
  );

  useEffect(() => {
    if (!isLoaded) {
      setLock(character.previousSave);
      setIsLoaded(true);
    }
  }, [loaded, character.previousSave, setLock, isLoaded]);

  useEffect(() => {
    if (location !== loc.pathname) {
      setLocation(loc.pathname);
      setLock(character.previousSave);
      setIsLoaded(false);
    }
  }, [character, loc.pathname, location, setLock]);

  return (
    <Box
      style={{
        position: 'relative',
        display: 'inline-block',
        overflow: 'hidden',
      }}
    >
      <IconButton
        onClick={handleLockClick}
        icon={buttonIcon}
        style={{ position: 'relative', zIndex: '0' }}
        width={'60px'}
      />
      <AnimatePresence mode="wait">
        {character.unsavedChanges && (
          <motion.button
            onClick={handleLockClick}
            initial={{ originX: 1, width: 0, left: 60, height: 40 }}
            animate={{ width: 60, left: 0, height: 40 }}
            exit={{ originX: 1, width: 0, left: 60, height: 40 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            whileHover={{ backgroundColor: theme.colors.buttonHover }}
            whileTap={{ backgroundColor: theme.colors.buttonClick }}
            style={{
              border: `3px solid ${theme.colors.lightGreen}`,
              background: theme.colors.buttonBackground,
              height: '40',
              borderRadius: 5,
              position: 'absolute',
              zIndex: '10',
              overflow: 'hidden',
              transformOrigin: 'right',
              top: 0,
              left: 0,
            }}
          >
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontWeight: 'bold',
              }}
            >
              {saveIcon}
            </span>
          </motion.button>
        )}
      </AnimatePresence>
    </Box>
  );
};
export default LockButton;
